import { render, staticRenderFns } from "./TimerBooster.vue?vue&type=template&id=7c5864a2&scoped=true"
import script from "./TimerBooster.vue?vue&type=script&lang=js"
export * from "./TimerBooster.vue?vue&type=script&lang=js"
import style0 from "./TimerBooster.vue?vue&type=style&index=0&id=7c5864a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5864a2",
  null
  
)

export default component.exports